import { gql } from '@apollo/client';

// Frases motivacionales del banner de progreso físico. Las activas las lee el cliente;
// el admin administra la lista (crear/eliminar).

export const MOTIVATIONAL_PHRASES = gql`
  query MotivationalPhrases {
    motivationalPhrases { id text author }
  }
`;

export const MANAGE_MOTIVATIONAL_PHRASES = gql`
  query ManageMotivationalPhrases {
    manageMotivationalPhrases { id text author is_active created_at }
  }
`;

export const CREATE_MOTIVATIONAL_PHRASE = gql`
  mutation CreateMotivationalPhrase($text: String!, $author: String) {
    createMotivationalPhrase(text: $text, author: $author) { id text author }
  }
`;

export const DELETE_MOTIVATIONAL_PHRASE = gql`
  mutation DeleteMotivationalPhrase($id: ID!) {
    deleteMotivationalPhrase(id: $id)
  }
`;
